import React from 'react';
import styled from "styled-components";
import { PrimaryButton } from "./PrimaryButton";
import { ButtonSize, NewButtonProps } from "./ButtonStyling";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { canUserAddAnotherTeam } from '@shared/utils/AccessControl';
import { Permission } from '@shared/models/user.models';
import { DialogIdentifiers, openDialog, openDialogWithPayload } from '@shared/store/dialog.duck';

export function AddAnotherTeamButton(props: NewButtonProps) {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const open = () => {
    if (canUserAddAnotherTeam(currentUser)) {
      dispatch(openDialog(DialogIdentifiers.CreateTeamDialog));
    } else {
      dispatch(openDialogWithPayload({
        activeDialog: DialogIdentifiers.PermissionNeededDialog,
        payload: {permissionRequired: Permission.CompanyAdmin},
      }));
    }
  }

  return (
    <BigMobilePrimaryButton size={props.size ?? ButtonSize.Medium}
                            fullWidth={!!props.fullWidth}
                            className={`wallchart__addTeams ${props.className || ''}`.trim()}
                            text="button.add-another-team"
                            dataTest="addAnotherTeam-button"
                            click={() => open()}/>
  )
}

const BigMobilePrimaryButton = styled(PrimaryButton)`
  height: 50px;
  margin: 0 auto;
`
